import React, { useState } from 'react'
import styles from './Nav.module.scss'
import { PreviewNavElement } from '../../types/Types'

const PreviewNav = ({els, type, onTabName}:{els:string[],type:string, onTabName:(name:string)=>void}) => {

    const [currentActive, setCurrentActive] = useState<number>(0);

    const changeTab = (index:number, name:string) => {
        setCurrentActive(index)
        onTabName(name);
    }

    return (
        <ul className={type === 'service' ? `body3 medium gs6 mgt16 ${styles.preview_nav} ${styles.service_nav}` : `body3 medium gs6 mgt16 ${styles.preview_nav} ${styles.manage_nav}`}>
            {els.map((element, index)=>{
                return <li key={index} onClick={()=>{changeTab(index, element)}} className={currentActive === index ? `${styles.active}` : styles.item }>{element}</li>
            })}
        </ul>
    )
}

export default PreviewNav
